import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Business Details")
], -1)
const _hoisted_3 = { class: "fv-row mb-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Telephone", -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Website", -1)
const _hoisted_7 = { class: "fv-row mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Currency", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "pound"
}, "£ (Pounds Sterling)", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "dollar" }, "$ (US Dollars)", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: "euro" }, "€ (Euros)", -1)
const _hoisted_12 = { class: "fv-row mb-10" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Geo Base", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  selected: "",
  value: "uk"
}, "UK", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: "us" }, "US", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "eu" }, "EU", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode(_component_Field, {
        modelValue: _ctx.telephone,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telephone) = $event)),
        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.limitInput($event))),
        onInput: _cache[2] || (_cache[2] = ($event: any) => {
          _ctx.fieldChanged($event);
          _ctx.formatTelephone($event);
        }),
        type: "textarea",
        name: "telephone",
        class: "form-control form-control-lg form-control-solid",
        rows: "10"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "telephone",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_Field, {
        modelValue: _ctx.website,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.website) = $event)),
        onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.fieldChanged($event))),
        type: "text",
        class: "form-control form-control-lg form-control-solid",
        name: "website",
        placeholder: "",
        value: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "website",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode(_component_Field, {
        modelValue: _ctx.currencyCode,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currencyCode) = $event)),
        onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.fieldChanged($event))),
        name: "currencyCode",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_9,
          _hoisted_10,
          _hoisted_11
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "currencyCode",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_component_Field, {
        modelValue: _ctx.geoFocusCountryCode,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.geoFocusCountryCode) = $event)),
        onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.fieldChanged($event))),
        name: "geoFocusCountryCode",
        class: "form-select form-select-lg form-select-solid",
        "data-control": "select2",
        "data-placeholder": "Select...",
        "data-allow-clear": "true",
        "data-hide-search": "true",
        as: "select"
      }, {
        default: _withCtx(() => [
          _hoisted_14,
          _hoisted_15,
          _hoisted_16
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ErrorMessage, {
        name: "geoFocusCountryCode",
        class: "fv-plugins-message-container invalid-feedback"
      })
    ])
  ]))
}